import axios from 'axios';
import router from './router';
import { useAuthStore } from './stores/AuthStore';

const baseURL = process.env.VUE_APP_API_URL;

export const api = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {"Content-Type": "multipart/form-data"},
  timeout: 30000,
  timeoutErrorMessage: 'Não foi possível realizar essa operação, tente novamente mais tarde',
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, error => {

  return Promise.reject(error);
});

api.interceptors.response.use(
  response => response,
  error => {
    // Timeout, queda de rede e request cancelado não têm response.
    if (!error.response) {
      return Promise.reject(error);
    }

    const authStore = useAuthStore();

    const currentPath = router.currentRoute.value.path;

    if (currentPath !== '/' && currentPath !== '/login' && error.response.status === 401) {
      authStore.logout();
      router.push({ name: 'login'});
    }


    if(error.response.status === 404){
        router.push({ name: '404'});
    }
    return Promise.reject(error);
  }
);